import React from 'react';
import {
  Card,
  CardBody,
  CardText,
  CardTitle,
  Col,
  ColProps,
  Container,
  Row,
} from 'reactstrap';
import classNames from 'classnames';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faClock, faDoorOpen, faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface AccessControlRuleProps {
  title: string;
  icon: IconDefinition;
}

const AccessControlRule: React.FC<AccessControlRuleProps> = props => {
  const { title, icon, children } = props;

  return (
    <Card className="border-0 rounded-lg card-shadow card-hover">
      <Row className="align-items-center">
        <Col xs={12} sm={2} md={12} className="text-primary-2-dark pr-0">
          <CardBody>
            <FontAwesomeIcon icon={icon} size="4x" />
          </CardBody>
        </Col>
        <Col>
          <CardBody>
            <CardTitle className="h5">{title}</CardTitle>
            <CardText>{children}</CardText>
          </CardBody>
        </Col>
      </Row>
    </Card>
  );
};

export const AccessControlRules: React.FC = props => {
  const cardColProps: ColProps = {
    xs: 12,
    md: 4,
    lg: 3,
    className: 'my-3',
  };

  const hrColProps: ColProps = {
    xs: 1,
    className: classNames('p-0', 'd-none', 'd-lg-block'),
  };

  const markClassName = classNames(
    'bg-light',
    // 'bg-primary',
    'rounded',
    'text-bold'
  );

  return (
    <Container className="my-5">
      <Row>
        <Col>
          <h2>Die volle Kontrolle.</h2>
          <hr />
          <p className="lead">
            Mit der richtigen Zutrittskontrolle steuern Sie,{' '}
            <mark className={markClassName}>WER</mark>{' '}
            <mark className={markClassName}>WANN</mark>{' '}
            <mark className={markClassName}>WOHIN</mark> Zutritt hat. Durch das
            richtige Zutrittskontrollsystem wird dies zum Kinderspiel.
          </p>
        </Col>
      </Row>

      <Row className="align-items-center justify-content-center">
        <Col {...cardColProps}>
          <AccessControlRule title="Wer" icon={faUser}>
            Gewähren Sie den Zugang nur für berechtigte Personen.
          </AccessControlRule>
        </Col>

        <Col {...hrColProps}>
          <hr />
        </Col>

        <Col {...cardColProps} lg={4}>
          <AccessControlRule title="Wann" icon={faClock}>
            Begrenzen Sie Zutrittsberechtigungen zeitlich (zum Beispiel
            Ablauffristen oder Uhrzeiten).
          </AccessControlRule>
        </Col>

        <Col {...hrColProps}>
          <hr />
        </Col>

        <Col {...cardColProps}>
          <AccessControlRule title="Wohin" icon={faDoorOpen}>
            Steuern Sie, welche Bereiche für welche Personen freigegeben sind.
          </AccessControlRule>
        </Col>
      </Row>
    </Container>
  );
};
